import { ONE_DAY_IN_SECONDS } from "./constants";

export const determineGender = genderId => (genderId === 1 ? "Мъж" : "Жена");

export const getInclusiveDayCount = (startDate, endDate) => {
  if (!startDate || !endDate) return null;
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start) || isNaN(end) || end < start) return null;
  const totalDays = Math.round((end - start) / ONE_DAY_IN_SECONDS) + 1;
  return totalDays;
};

export const determineStatus = (startsInDays, endsInDays) => {
  const status =
    startsInDays > 0
      ? `Предстояща (след ${startsInDays} дни)`
      : endsInDays > 0
        ? `Текуща (остават ${endsInDays} дни)`
        : "Завършена";

  return status;
};

export const getDisplayName = record =>
  record
    ? record.secondName
      ? `${record.firstName} ${record.secondName} ${record.lastName}`
      : `${record.firstName} ${record.lastName}`
    : "";

// Shared query-string builder: skipScalar gates top-level values, skipItem gates individual
// array items (they differ for buildQueryParams — see below). Array values are appended once
// per item under the same key (e.g. { Ids: [1, 2] } -> "Ids=1&Ids=2").
const build = (paramsObject, skipScalar, skipItem) => {
  const params = new URLSearchParams();
  Object.entries(paramsObject).forEach(([key, value]) => {
    if (skipScalar(value)) return;
    if (Array.isArray(value)) {
      value.filter(item => !skipItem(item)).forEach(item => params.append(key, item));
    } else {
      params.append(key, value);
    }
  });
  return params.toString();
};

// Builds the "?"-prefixed suffix ready to append to a URL (or "" when there are no params),
// e.g. `${path}${buildQueryString({ Id: id })}`. Skips only undefined for scalar values —
// matches this codebase's established `if (x !== undefined) params.append(...)` convention, so
// an explicit null scalar is still sent (and rejected loudly by the backend) rather than
// silently dropped. Array ITEMS are held to a stricter rule and additionally skip null: a
// missing scalar wrapped into an array (e.g. `[ids].flat()`-style builders) becomes
// undefined/null inside the array, and that must never reach the backend as the literal string
// "undefined"/"null".
export const buildQueryString = (paramsObject = {}) => {
  const queries = build(
    paramsObject,
    v => v === undefined,
    v => v === undefined || v === null,
  );
  return queries ? `?${queries}` : "";
};

// Like buildQueryString, but also skips null and empty-string values — for filter/pagination
// objects where "" or null mean "not set" rather than a literal value to send (matches the
// semantics already used by studentApi.js's getWeeklyTabbedScheduleCalendar). Scalars and array
// items share the same predicate here, unlike buildQueryString.
export const buildFilterQueryString = (paramsObject = {}) => {
  const isUnset = v => v === undefined || v === null || v === "";
  const queries = build(paramsObject, isUnset, isUnset);
  return queries ? `?${queries}` : "";
};

// yyyy-MM-dd for date-scoped URL path segments — form and backend values may carry a time part.
export const toDateOnly = date => (date ? String(date).slice(0, 10) : date);

const DATE_TIME_NO_SECONDS_FORMAT = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

// "dd.mm.yyyy г., HH:mm ч." — bg-BG drops its " ч." suffix once seconds are omitted, so it is appended here.
export const formatDateTime = value =>
  value ? `${new Date(value).toLocaleString("bg-BG", DATE_TIME_NO_SECONDS_FORMAT)} ч.` : "";

